var map = {
	"./en": 222,
	"./en/": 222,
	"./en/Default": 258,
	"./en/Default.js": 258,
	"./en/Forms": 259,
	"./en/Forms.js": 259,
	"./en/Login": 260,
	"./en/Login.js": 260,
	"./en/Menu": 261,
	"./en/Menu.js": 261,
	"./en/Modals": 262,
	"./en/Modals.js": 262,
	"./en/Resources": 263,
	"./en/Resources.js": 263,
	"./en/Tables": 264,
	"./en/Tables.js": 264,
	"./en/Types": 265,
	"./en/Types.js": 265,
	"./en/index": 222,
	"./en/index.js": 222,
	"./es": 199,
	"./es/": 199,
	"./es/Default": 250,
	"./es/Default.js": 250,
	"./es/Forms": 251,
	"./es/Forms.js": 251,
	"./es/Login": 252,
	"./es/Login.js": 252,
	"./es/Menu": 253,
	"./es/Menu.js": 253,
	"./es/Modals": 254,
	"./es/Modals.js": 254,
	"./es/Resources": 255,
	"./es/Resources.js": 255,
	"./es/Tables": 256,
	"./es/Tables.js": 256,
	"./es/Types": 257,
	"./es/Types.js": 257,
	"./es/index": 199,
	"./es/index.js": 199,
	"./i18n": 208,
	"./i18n.js": 208,
	"./translation.service": 2,
	"./translation.service.js": 2
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 466;